export default __webpack_public_path__ + "static/media/homeHero.edb4b84b.jpg";